import { useMutation } from '@tanstack/react-query';
import api from '../../services/api';
import { ProductVideo } from './types';

const getProductVideo = async ({
  merchant_id,
  product_id,
}: {
  merchant_id: string;
  product_id: string;
}) => {
  const { data } = await api.get<{ video: ProductVideo | null }>(
    `/all/merchants/${merchant_id}/products/${product_id}/video`,
  );
  return data;
};

export function useGetProductVideo() {
  return useMutation(['getProductVideo'], getProductVideo, {
    retry: false,
  });
}
